import React from 'react'

const PaymentFailedPage = () => {
    return (
        <div className="h-screen bg-gray-100">
            <div className="flex items-center justify-center h-full p-6 bg-white md:mx-auto">
                <div>

                    <img src="/img/failed.gif" className='h-20 m-auto' alt='failed' />
                    <div className="text-center">
                        <h3 className="text-base font-semibold text-center text-gray-900 md:text-2xl">Payment failed!</h3>
                        <p className="my-2 text-gray-600">please try again</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentFailedPage